import type RegisterOrganization from 'register-partners-js/models/register-organization';
import type Registration from 'register-partners-js/models/registration';

export const shouldRedirectToEmbed = (
  registration: Registration,
  organization: RegisterOrganization
): boolean => {
  return registration.isEmbedded && !organization?.underRegistration;
};
